module.exports = __webpack_public_path__ + "static/media/SuperShuttle_android_2_preview.1a108deb.jpg";